import { usePagesPage } from "modules/brands/context";
import { getTextForDeletingPopup } from "modules/brands/utils";
import DeleteConfirmationModal from "shared/components/DeleteConfirmationModal";

const DeleteModals = () => {
  const {
    deleteDefaultPageModal,
    unpublishDefaultPageModal,
    isLoadingDeletePage,
    handleDeletePage,
    regularDeleteModal,
  } = usePagesPage();

  return (
    <>
      <DeleteConfirmationModal
        title={`Delete “${regularDeleteModal.modalDetails?.title || ""}” Page`}
        content={getTextForDeletingPopup(
          regularDeleteModal.modalDetails?.modulesCount || 0,
        )}
        applyButtonTitle="Yes, delete"
        onClose={regularDeleteModal.closeModal}
        open={regularDeleteModal.isOpen}
        handleSuccess={handleDeletePage}
        applyButtonLoading={isLoadingDeletePage}
      />
      <DeleteConfirmationModal
        title="Cannot Delete “Home” Page"
        content={
          "This page is currently set as the default page for either authenticated or unauthenticated and cannot be deleted. To proceed with deletion, please first set another page as the default."
        }
        cancelButtonTitle="Cancel"
        onClose={deleteDefaultPageModal.closeModal}
        open={deleteDefaultPageModal.isOpen}
        handleSuccess={deleteDefaultPageModal.closeModal}
      />
      <DeleteConfirmationModal
        title="Cannot Unpublish “Home” Page"
        content={
          "This page has been set as the default for authorized or unauthorized and must remain published. To unpublish this page, please assign another page as the default for the corresponding user group."
        }
        cancelButtonTitle="Cancel"
        onClose={unpublishDefaultPageModal.closeModal}
        open={unpublishDefaultPageModal.isOpen}
        handleSuccess={unpublishDefaultPageModal.closeModal}
      />
    </>
  );
};

export default DeleteModals;
